export const expertOptionConst: {
  id: number;
  label: string;
  value: string;
}[] = [
  {
    id: 0,
    label: "ساناز اشرفی ",
    value: "0",
  },
  {
    id: 1,
    label: "آیدا شایقی",
    value: "1",
  },
];
